import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/info.svg'

export const Info = withSvgProps(SvgComponent)
